import {Observable} from 'rxjs/Observable';
import {copyChallengeCompleted, errorCopyingChallengeAction, Types} from "./actions";

import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import {isNoU} from "../../utils/DBUtils";

const submitCopyChallengeEpic = ($action, store) => $action.ofType(Types.SUBMIT_COPY_CHALLENGE)
    .mergeMap((action) => {
        const state = store.getState();
        let masterId = state.copyChallenge.copyChallengeId;
        return ResourceApi.copy(ResourceApi.Types.Break, {
                permalink: action.permalink,
                lang: action.lang
            }, [{type: ResourceApi.Types.Break, id: masterId}])
                .mergeMap((response) => Observable.of(
                    copyChallengeCompleted(response.response.object.challengeId),
                    ResourceActions.createdResourceAction(response.response.object, null, [], [], [])
                )).catch(err => Observable.of(
                    !isNoU(err.xhr) ? errorCopyingChallengeAction(err.response)
                        : {type: "ERROR", error: err}))
        }
    );

export default [
    submitCopyChallengeEpic
]



// WEBPACK FOOTER //
// ./public/pages/BreakCopy/epics.js